import type { OrganizationSearchRequestDto } from '../types/search-request.dto';
import type { OrganizationSearchRequestModel } from '../types/search-request.model';

import { toSearchRequestDto } from '@/features/Shared/model/mappers/search-request.dt';

export const toOrganizationSearchRequestDto = (
	model: OrganizationSearchRequestModel
): OrganizationSearchRequestDto => {
	return {
		...toSearchRequestDto(model),
		title: model.title,
	};
};
